import { Discount_PlatformAvailability } from '@app/_proto/Protos/discounts';
import type { SponsorPlanItem } from '@app/_proto/Protos/sponsors';
import type { SubscriptionItem } from '@app/_proto/Protos/subscriptions';
import type { Timestamp } from '@app/_proto/google/protobuf/timestamp';
import { timestampToDate } from '@app/libs/utils';

type ChampionDiscountStateReturn = {
    plansWithDiscount?: SponsorPlanItem[] | undefined;
    discountText?: string | undefined;
    endsAt?: Timestamp | undefined;
};

export const championDiscountState = (
    currentSubscription: SubscriptionItem | null,
    sortedSponsorPlans: SponsorPlanItem[]
): ChampionDiscountStateReturn => {
    if (currentSubscription || sortedSponsorPlans.length === 0) {
        return {};
    }

    const plansWithDiscount = sortedSponsorPlans.filter(
        plan =>
            (plan.discountInfo?.discounts.filter(d =>
                d.platformAvailability.filter(a => a === Discount_PlatformAvailability.Web)
            ).length ?? 0) > 0
    );

    const discounts = plansWithDiscount
        .flatMap(p => p.discountInfo!.discounts)
        .sort((a, b) => {
            const firstEndAt = timestampToDate(a.endsAt)?.getTime();
            const secondEndAt = timestampToDate(b.endsAt)?.getTime();

            return !firstEndAt || !secondEndAt ? 1 : firstEndAt - secondEndAt;
        });

    if (discounts.length === 0) {
        return {};
    }

    const [firstDiscount] = discounts;

    return {
        plansWithDiscount: plansWithDiscount,
        discountText: firstDiscount.shortDescription?.value ?? 'discount',
        endsAt: firstDiscount.endsAt,
    };
};
